import { combineReducers } from 'redux';
import sessionReducer from './sessionReducer';
import suppliersReducer from './suppliersReducer';
const rootReducer = combineReducers({
  session: sessionReducer,
  suppliers:suppliersReducer
});

export default rootReducer;